import React, { useContext } from "react";
import { Badge, Button, Tooltip } from "antd";
import { FaSearch } from "react-icons/fa";
import language from "../../resources/languages/fa_IR";
import { ActionType, Enum } from '../../resources/constants';

// Contexts
import GlobalContext from "../../contexts/global";

const { Components: { Filter } } = language
const { SET_OPEN_DRAWER, SET_OPEN_TOUR, SET_FORM } = ActionType
const { Form } = Enum

export default function Index(props: { tour: React.RefObject<HTMLInputElement> }) {

    const { tour} = props
    const { filter, openDrawer, isOpenFloatButton, dispatch } = useContext(GlobalContext)

    return (
        <Tooltip placement="top" title={Filter.filter} overlayClassName={'button-tooltip'} open={!openDrawer && !isOpenFloatButton}>
            <Badge count={Object.values(filter).filter(value => value).length} >
                <Button
                    type="primary"
                    shape="round"
                    // @ts-ignore
                    ref={tour}
                    icon={<FaSearch size={28} />}
                    size={'large'} onClick={() => {
                    dispatch({ type: SET_OPEN_TOUR , payload: { openTour: false }})
                    dispatch({ type: SET_FORM , payload: { form: Form.FILTER }})
                    dispatch({ type: SET_OPEN_DRAWER , payload: { openDrawer: true }})
                }} />
            </Badge>
        </Tooltip>
    );
};
